import { render, staticRenderFns } from "./JobTutorial_view.vue?vue&type=template&id=5b2f1a10&scoped=true&"
import script from "./JobTutorial_view.vue?vue&type=script&lang=js&"
export * from "./JobTutorial_view.vue?vue&type=script&lang=js&"
import style0 from "./JobTutorial_view.vue?vue&type=style&index=0&id=5b2f1a10&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2f1a10",
  null
  
)

export default component.exports